<template>
  <div class="contents_wrapper">
    <div class="contents">
      <template v-if="isNoSkill">
        <h2 class="large_label">案件を探すにはスキル・ソフト登録が必要です</h2>
        <router-link class="active-rectangle_button" :to="{name: 'RegisterUserSkill', params: null}">
          スキル・ソフトウェア登録
        </router-link>
      </template>
      <template v-else>
        <template v-if="isSearching">
          <h2 class="large_label">案件の受注を停止する</h2>
          <button @click="updateOperatorStatusWaiting()" class="active-rectangle_button">作業を停止する</button>
        </template>

        <template v-if="isWaiting || isMissing">
          <h2 class="large_label">案件を受注する</h2>
          <p class="bold_label">1. 現在からの空き時間を入力してください</p>
          <TimeFormBox v-model="freeMoment" :max="720"/>

          <button @click="updateOperatorStatusSearching()" class="active-rectangle_button">作業を受け付ける</button>
        </template>

        <template v-if="isMatching">
          <p class="bold_label">マッチング中は新たな案件の受注は出来ません</p>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import UpdatingOperator from "@/assets/js/pages/mypage/operator/UpdatingOperator";
  import {mapGetters} from "vuex";
  import moment from "moment";
  import firebase from "firebase";
  import TimeFormBox from "@/components/molecules/box/form/TimeFormBox";
  import collection from '@/assets/js/functions/firebase/firestore/collection';
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";

  export default {
    name: "UpdatingOperator",

    components: {TimeFormBox},

    mixins: [UpdatingOperator, collection],

    data() {
      return {
        renewOperator: {
          freeMoment: 0,
        },
        freeMoment: {
          hour: 0,
          minute: 0,
        },
        isNoSkill: false,
        isSearching: false,
        isWaiting: false,
        isMatching: false,
        isMissing: false,
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      freeMomentEnd() {
        const now = moment();
        const freeMoment = this.freeMoment.hour * 60 + this.freeMoment.minute;
        return now.add(freeMoment, 'm').toDate()
      }
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(
        COLLECTION_NAMES.USER_DETAILS,
        this.uid,
        {}).then(userDetail => {
        if (!userDetail.skills || !userDetail.softwares) {
          this.isNoSkill = true;
        }
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
      if (this.isNoSkill) return;

      await this.getDoc(
        'operators',
        this.uid,
        {}).then(operator => {
        if (operator && (operator.status === 'searching')) {
          this.isSearching = true;
        } else if (operator && (operator.status === 'waiting')) {
          this.isWaiting = true;
        } else if (operator && (operator.status === 'missing')) {
          this.isMissing = true;
        } else {
          this.isMatching = true;
        }
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

    },

    methods: {
      isValidRenewOperator() {
        if (!this.renewOperator.freeMoment || this.renewOperator.freeMoment < 0) {
          this.showErrorMessage('現在からの空き時間を入力してください');
          return false;
        }
        return true;
      },

      async updateOperatorStatusSearching() {
        this.renewOperator['freeMoment'] = this.freeMomentEnd;
        if (!this.isValidRenewOperator()) return;

        const mergeParams = {
          status: "searching",
          startAt: firebase.firestore.FieldValue.serverTimestamp()
        };
        const requestParams = {...mergeParams, ...this.renewOperator};

        await this.updateDoc(
          'operators',
          this.uid,
          requestParams
        ).then(() => {
          this.showSuccessMessage('案件の受注を開始しました。');
          this.$router.push({name: 'OperatorTop'})
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      },

      async updateOperatorStatusWaiting() {
        this.renewOperator['freeMoment'] = null;
        const mergeParams = {
          status: "waiting",
          startAt: null
        };
        const requestParams = {...mergeParams, ...this.renewOperator};

        await this.updateDoc(
          'operators',
          this.uid,
          requestParams
        ).then(() => {
          this.showSuccessMessage('案件の受注を停止しました。');
          this.$router.push({name: 'OperatorTop'})
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $operator_primary;

    > .contents {
      @include form-contents();
    }
  }
</style>